export enum CompanyBadgesTableRows {
  NAME,
  STATUS,
  CUSTOMER_TYPE,
  PRODUCT_NAME,
  PAYMENT_STATUS,
  BADGE
}
